import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { getPerson as getPersonAction } from "../../actions-index";
import { useSelector } from "react-redux";
function useLookup() {
  const dispatch = useDispatch();
  const [localStatus, setLocalStatus] = useState("");
  const [approverValue, setApproverValue] = useState("");
  const storedPerson = useSelector((state) => {
    return state.person
  });

  const getPerson = (value) => {
    if(value) {
      setLocalStatus("loading");
      setApproverValue(value);
      if (value.trim().length > 0) {
        dispatch(getPersonAction(value));
        setLocalStatus("");
      } else {
        setLocalStatus("error");
      }
    }
  };

  let person = useMemo(() => {
      if (
        approverValue &&
        storedPerson?.data?.emplid &&
        storedPerson?.data?.emplid === approverValue
      ) {
        return storedPerson?.data
      } else if (storedPerson?.archive?.[approverValue]) {
        return storedPerson.archive[approverValue]
      }
      return {}
  }, [approverValue, storedPerson?.data, storedPerson?.archive])

  return {
    getPerson,
    person: person || {},
    setPersonEmplid: setApproverValue,
    status: localStatus || storedPerson?.status
  };
}

export default useLookup;
